<p-toast position="top-right" key="base-table-{{ uniqueId }}"></p-toast>
<div [ngClass]="tableConfig.wrapperClass">
  <p-table
    #dt
    [value]="data"
    dataKey="id"
    styleClass="{{
      tableConfig.responsive
        ? 'p-datatable-gridlines p-datatable-data'
        : 'p-datatable-gridlines'
    }} "
    [rowHover]="true"
    sortMode="multiple"
    [rows]="tableConfig.size"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [loading]="tableConfig.loading"
    [paginator]="tableConfig.pagging && enablePaging"
    [totalRecords]="totalRows"
    [currentPageReportTemplate]="generalTexts.currentPageReport.label || ''"
    [lazy]="tableConfig.lazy && pagingType === 'server-side'"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="loadData($event)"
    [globalFilterFields]="globalFilterFields"
    [resizableColumns]="true"
    columnResizeMode="expand"
    (onFilter)="onFilter($event)"
    filterDelay="500"
    [responsive]="tableConfig.responsive"
  >
    <ng-template pTemplate="caption">
      <div class="p-d-flex p-ai-center p-jc-between">
        <div>
          <span class="p-input-icon-left" *ngIf="tableConfig.title">
            <h5>{{ generalTexts.titleText?.label || tableConfig.title }}</h5>
          </span>
        </div>
        <div style="display: flex; flex-direction: row">
          <div>
            <ng-container *ngIf="tableConfig.hasHeaderCustomAction">
              <app-custom-action
                [data]="headerData"
                [component]="customAction"
                (onTrigger)="handleCustomAction($event)"
              ></app-custom-action>
            </ng-container>
          </div>

          <div>
            <span class="p-input-icon-left" *ngIf="tableConfig.globalSearch">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                (input)="handleGlobalSearch($event)"
                placeholder="{{ generalTexts.search.label }}"
              />
            </span>
            <p-multiSelect
              [options]="cols"
              *ngIf="tableConfig.columnCustomizer"
              [(ngModel)]="tableCols"
              defaultLabel="Select columns"
              optionLabel="header"
            ></p-multiSelect>
            <button
              pButton
              pRipple
              [label]="generalTexts.newButton.label"
              icon="pi pi-plus"
              class="p-button p-mx-2"
              [pTooltip]="generalTexts.newButtonHelpText.label"
              tooltipPosition="bottom"
              (click)="openNew()"
              *ngIf="tableConfig.newRecordButton && !readonly"
            ></button>
          </div>
          <div>
            <button
              type="button"
              *ngIf="tableConfig.excel.uploadUrl"
              pButton
              pRipple
              icon="pi pi-file-excel"
              (click)="uploadExcel()"
              class="p-button-success p-mr-2"
              [pTooltip]="generalTexts.uploadXls.label"
              [label]="generalTexts.uploadXls.label"
              tooltipPosition="bottom"
            ></button>
            <button
              type="button"
              *ngIf="tableConfig.excel.downloadUrl"
              pButton
              pRipple
              icon="pi pi-file-excel"
              (click)="downloadExcelTemplate()"
              class="p-button-warning p-mr-2"
              [pTooltip]="generalTexts.downloadTemplate.label"
              [label]="generalTexts.downloadTemplate.label"
              tooltipPosition="bottom"
            ></button>
          </div>
          <div *ngIf="tableConfig.export">
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-file-excel"
              (click)="exportExcel()"
              class="p-button-success p-mr-2"
              [pTooltip]="generalTexts.downloadXLs.label"
              tooltipPosition="bottom"
            ></button>
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-file-pdf"
              (click)="exportPdf()"
              class="p-button-warning p-mr-2"
              [pTooltip]="generalTexts.downloadPdf.label"
              tooltipPosition="bottom"
            ></button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="tableConfig.dataSelection" style="width: 45px">
          <p-checkbox
            [ngModel]="allSelected"
            [binary]="true"
            (onChange)="selectAll($event)"
            [disabled]="dataSelectionDisabaled"
          ></p-checkbox>
        </th>
        <!-- <th style="width: 3rem"></th> -->
        <ng-container *ngFor="let col of tableCols">
          <th
            *ngIf="!(col.type == 'hidden')"
            pSortableColumn="{{ col.sort ? col.filterKey || col.field : '' }}"
            pResizableColumn
          >
            {{ col.label }}
            <p-sortIcon
              *ngIf="col.sort"
              field="{{ col.filterKey || col.field }}"
            ></p-sortIcon>
          </th>
        </ng-container>
        <th style="width: max(8rem)" *ngIf="!actionColumnHidden">
          {{ generalTexts.action.label }}
        </th>
      </tr>
      <tr *ngIf="shouldShowHeaderFilterRow(tableCols)">
        <th *ngIf="tableConfig.dataSelection"></th>
        <ng-container *ngFor="let col of tableCols">
          <th *ngIf="!(col.type == 'hidden')">
            <span
              class="p-input-icon-right eight-rem"
              *ngIf="col.filter == 'search'"
            >
              <i
                class="pi pi-times"
                *ngIf="searchFilter[col.field]"
                (click)="clearSearchFilter(col)"
              ></i>
              <i class="pi pi-search" *ngIf="!searchFilter[col.field]"></i>
              <input
                pInputText
                type="text"
                [(ngModel)]="
                  col.filterKey
                    ? searchFilter[col.filterKey]
                    : searchFilter[col.field]
                "
                (input)="handleInputSearch($event, col)"
                placeholder="{{ generalTexts.searchBy.label }} {{ col.label }}"
                class="p-column-filter"
              />
            </span>
            <p-calendar
              *ngIf="col.filter == 'date'"
              (onSelect)="onDateSelect($event, col)"
              (onClearClick)="
                dt.filter('', col.filterKey || col.field, 'equals')
              "
              [showButtonBar]="true"
              appendTo="body"
              class="eight-rem"
              styleClass="p-column-filter"
              placeholder="{{ col.label }} Date"
              [readonlyInput]="true"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <p-dropdown
              *ngIf="
                col.filter == 'select' && col.options && col.options.length
              "
              [options]="col.options"
              [autofocusFilter]="false"
              [(ngModel)]="col.defaultOption"
              dataKey="id"
              (onChange)="onSelectChange($event, col)"
              styleClass="p-column-filter"
              appendTo="body"
              class="eight-rem"
              placeholder="Select a {{ col.label }}"
              [showClear]="true"
            >
              <ng-template let-option pTemplate="item" *ngIf="col.options">
                <span>{{ option.label }}</span>
              </ng-template>
            </p-dropdown>
            <p-multiSelect
              *ngIf="
                col.filter == 'multiselect' && col.options && col.options.length
              "
              [options]="col.options || []"
              placeholder="All"
              [autofocusFilter]="false"
              (onChange)="onMultiSelectChange($event, col.field)"
              styleClass="p-column-filter"
              optionLabel="name"
              class="eight-rem"
              appendTo="body"
            >
              <ng-template let-option pTemplate="item" *ngIf="col.options">
                <div class="p-multiselect-representative-option">
                  <span class="p-ml-1">{{ option.label }}</span>
                </div>
              </ng-template>
            </p-multiSelect>
          </th>
        </ng-container>
        <th *ngIf="!actionColumnHidden"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
      <tr class="p-selectable-row" [ngClass]="getRowClass(data)">
        <td *ngIf="tableConfig.dataSelection" style="width: 45px">
          <p-checkbox
            [(ngModel)]="dataSelected"
            [value]="data"
            (onChange)="selectIndividual($event, data)"
            [disabled]="dataSelectionDisabaled"
          ></p-checkbox>
        </td>
        <ng-container *ngFor="let col of tableCols">
          <td *ngIf="!(col.type == 'hidden')">
            <img
              *ngIf="col.image"
              [alt]="data[col.field] && data[col.field]['name']"
              src="{{ data[col.image] }}"
              width="32"
              class="{{
                col.image_view === 'circle' ? 'image-circle' : 'image-plan'
              }}"
            />
            <ng-container *ngIf="!col.asyncType; else asyncType">
              <ng-container *ngIf="col.infoModal; else content">
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-info-circle"
                  class="p-button-rounded p-button-text"
                  (click)="infoClick(data)"
                ></button>
              </ng-container>
              <ng-template #content>
                {{ getCellData(data, col) }}
              </ng-template>
            </ng-container>
            <ng-template #asyncType>
              {{ getContent(data, col) | async }}
            </ng-template>
          </td>
        </ng-container>
        <td *ngIf="!actionColumnHidden" style="min-height: 40px">
          <button
            pButton
            pRipple
            icon="pi pi-eye"
            class="p-button-rounded p-button-success p-mr-2"
            (click)="viewData(data)"
            *ngIf="
              hasPermission('view') &&
              tableConfig.viewButton &&
              readonly &&
              (data.action ? data.action.view : true)
            "
            type="button"
          ></button>
          <button
            pButton
            pRipple
            type="button"
            class="p-button-rounded p-mr-2"
            (click)="editData(data)"
            [icon]="
              tableConfig.editBtnToView || readonly
                ? 'pi pi-eye'
                : 'pi pi-pencil'
            "
            *ngIf="
              hasPermission('edit') &&
              tableConfig.editButton &&
              !readonly &&
              (data.action ? data.action.edit : true)
            "
          ></button>
          <button
            pButton
            pRipple
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-mr-2"
            (click)="deleteData(data)"
            *ngIf="
              hasPermission('delete') &&
              tableConfig.deleteButton &&
              !readonly &&
              (data.action ? data.action.delete : true)
            "
            type="button"
          ></button>
          <ng-container *ngIf="tableConfig.hasCustomAction">
            <app-custom-action
              [data]="data"
              [component]="customAction"
              (onTrigger)="handleCustomAction($event)"
              *ngIf="
                tableConfig.hasCustomAction &&
                (data.action ? data.action.custom : true)
              "
            ></app-custom-action>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="tableCols?.length + 1">
          {{ generalTexts.noDataText.label }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-container *ngIf="formFields && visible">
  <app-entity-form
    [config]="tableConfig"
    [readonly]="readonly"
    [postData]="postData"
    [fields]="formFields"
    [uniqueId]="uniqueId"
    [transformModelFn]="transformModelFn"
    (onToggle)="handleFormToggle($event)"
    [isNew]="isNew"
    [visible]="visible"
    [data]="editRecord"
    (onSave)="handleSave()"
    (onFormInit)="getFormGroup($event)"
  ></app-entity-form>
</ng-container>
<p-confirmDialog
  header="Confirmation"
  appendTo="body"
  [style]="{ width: '450px' }"
></p-confirmDialog>
<app-excel-upload-form
  [visible]="isXlsUpload"
  (onToggle)="handleExcelToggle($event)"
  (onImport)="handleImport()"
  [config]="tableConfig"
  [uniqueId]="uniqueId"
></app-excel-upload-form>
